import { gql } from '@apollo/client';

export const GET_DRIVER_LOCATION_TRACKS = gql`
  query GetDriverLocationTracks(
    $driverAccountId: String!
    $startTime: String!
    $endTime: String!
    $dataSource: String
  ) {
    getDriverLocationTracks(
      driverAccountId: $driverAccountId
      startTime: $startTime
      endTime: $endTime
      dataSource: $dataSource
    ) {
      id
      driverAccountId
      latitude
      longitude
      horizontalAccuracy
      verticalAccuracy
      altitude
      locationType
      bearing
      gpsStatus
      operatingSystem
      locationTimestamp
      timezone
      phoneModel
      speed
      dataSource
      createdAt
    }
  }
`;

export interface DriverLocationTrackType {
  id: string;
  driverAccountId: string;
  latitude: number;
  longitude: number;
  horizontalAccuracy: number | null;
  verticalAccuracy: number | null;
  altitude: number | null;
  locationType: string;
  bearing: number | null;
  gpsStatus: number | null;
  operatingSystem: string;
  locationTimestamp: string;
  phoneModel: string | null;
  speed: number | null;
  timezone: string | null;
  dataSource: string;
  createdAt: string;
}

export interface GetDriverLocationTracksResponse {
  getDriverLocationTracks: DriverLocationTrackType[];
}

